import React, { useState } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import 'keen-slider/keen-slider.min.css';

export default function FeaturedNewsSection() {
    const [currentSlide, setCurrentSlide] = useState(0);

    const newsData = [
        {
            id: 1,
            category: "News",
            title: "Mobikode Announces the Acquisition of Avant Techno Solutions to Expand Payment Modernization and Wealth Management Capabilities",
            image: "/assets/insights/img1.png"
        },
        {
            id: 2,
            category: "Trending",
            title: "Transforming Financial Ecosystems: The Future of Unified Payment Interfaces and Wealth Management Tech",
            image: "/assets/insights/img1.png"
        },
        {
            id: 3,
            category: "Insights",
            title: "How Payment Modernization Drives Enterprise Growth in Emerging Global Markets and Assets Management",
            image: "/assets/insights/img1.png"
        }
    ];

    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 0,
        loop: true,
        mode: "snap",
        slides: {
            perView: 1,
            spacing: 24,
        },
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
    });

    return (
        <section className="bg-white py-12 sm:py-16 lg:py-24 select-none text-left relative z-10 overflow-hidden">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] w-full">

                <div className="flex items-center justify-between mb-8 sm:mb-12 px-1">
                    <h2 className="text-[#01386A] font-sora font-[600] text-[20px] md:text-[30px] tracking-tight">
                        Featured News
                    </h2>

                    <div className="flex items-center gap-3 shrink-0">
                        <button
                            onClick={(e) => e.stopPropagation() || instanceRef.current?.prev()}
                            className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border border-[#ED6800] flex items-center justify-center text-[#ED6800] hover:bg-orange-50 active:scale-95 transition-all duration-200 cursor-pointer outline-none"
                            aria-label="Previous slide"
                        >
                            <ChevronLeft className="w-4 h-4 sm:w-5 sm:h-5 stroke-[2.5]" />
                        </button>
                        <button
                            onClick={(e) => e.stopPropagation() || instanceRef.current?.next()}
                            className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border border-[#ED6800] flex items-center justify-center text-[#ED6800] hover:bg-orange-50 active:scale-95 transition-all duration-200 cursor-pointer outline-none"
                            aria-label="Next slide"
                        >
                            <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 stroke-[2.5]" />
                        </button>
                    </div>
                </div>

                <div className="w-full relative">
                    <div ref={sliderRef} className="keen-slider">
                        {newsData.map((item) => (
                            <div key={item.id} className="keen-slider__slide w-full">
                                <div className="w-full bg-white border border-[#BAC9D7] p-[16px] sm:p-10 lg:p-[50px] flex flex-col md:flex-row gap-6 lg:gap-12 items-center transition-all duration-500 group">

                                    <div className="w-full md:w-1/2 aspect-[16/10] rounded-[4px] overflow-hidden shrink-0 bg-gray-50 relative">
                                        <img
                                            src={item.image}
                                            alt={item.title}
                                            className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-104"
                                        />
                                        <div className="absolute inset-0 bg-[#82271F]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                                    </div>

                                    <div className="w-full md:w-1/2 flex flex-col items-start text-left space-y-3 sm:space-y-4">
                                        <span className="text-[#ED6800] font-graphik font-[500] text-[14px] sm:text-[16px] tracking-wide block">
                                            {item.category}
                                        </span>

                                        <h3 className="text-[#01386A] font-sora font-[600] text-[16px] lg:text-[20px] leading-[1.3] tracking-tight transition-colors duration-300 line-clamp-4 sm:line-clamp-3 md:line-clamp-4">
                                            {item.title}
                                        </h3>

                                        <div className="pt-2 sm:pt-4">
                                            <a
                                                href="#"
                                                className="inline-flex items-center gap-1.5 text-[13px] sm:text-[16px] font-[600] text-[#01386A] border-b border-[#2A4C55] font-graphik pb-0.5 hover:text-orange-500 hover:border-orange-500 transition-all duration-300 group/link"
                                            >
                                                <span>Read More</span>
                                                <span className="transform transition-transform duration-300 group-hover/link:translate-x-1 text-orange-500 font-bold">
                                                    &gt;
                                                </span>
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </section>
    );
}